<template>
  <div v-if="$store.state.poi_data">
    <div v-for="(station, ind) in $store.state.poi_data" :key="ind + 'poly'">
      <div v-if="station.geom && selected_obj">
       
        <l-geo-json 
          :geojson="{
            type: 'FeatureCollection',
            features: [
              {
                type: 'Feature',
                geometry: JSON.parse(station.geom),
                properties: station,
              },
            ],
          }"
          :options="{ 
            style: () => ({
              fillColor: 'transparent',
              color: selected_obj.legend[station[selected_radio_group]],
              zIndex: 1 // Include all styles here
            }),
            onEachFeature: onEachFeature 
          }"
        ></l-geo-json>
      </div>
    </div>
  </div>
</template>

<script>
import axios_django from "../axios-auth";
import axios_all from "axios";
import info_popup from '../json/info_popup.json'

export default {
  name: 'ParcelsPoly',
  props: {
    ref_map: Object,
    selected_radio_group: String
  },
  data() {
    return {
      poi_data: null,
      array_of_poly_values: ['ΝΑΙ', 'ΚΕΝΟΣ', 'ΟΧΙ'],
      polygon_color: ['red', 'orange', 'blue'],
      filter_columns: null,
      selected_obj: null,
      info_popup:info_popup
    };
  },
  
  async created() {
    this.filter_columns = await axios_all.get('/json/filter_columns.json');
    this.filter_columns = this.filter_columns.data;
    this.loadchurch();
    console.log(this.selected_radio_group);
    console.log(this.filter_columns);
    
    for (var tt = 0; tt < this.filter_columns.length; tt++) {
      if (this.filter_columns[tt].value === this.selected_radio_group) {
        this.selected_obj = this.filter_columns[tt];
      }
    }
  },
  
  watch: {
    selected_radio_group(newVal, oldVal) {
      console.log('selected_radio_group changed:', oldVal, '=>', newVal);
      
      for (var tt = 0; tt < this.filter_columns.length; tt++) {
        if (this.filter_columns[tt].value === newVal) {
          this.selected_obj = this.filter_columns[tt];
          break;
        }
      }
    }
  },
  
  methods: {
    loadchurch() {
      console.log('loadchurch');
      console.log(this.ref_map);
      const bounds = this.ref_map.mapObject.getBounds();
      const bbox = [
        bounds.getSouthWest().lng, bounds.getSouthWest().lat,
        bounds.getNorthEast().lng, bounds.getNorthEast().lat
      ].join(',');
      console.log(bbox);
      var token = localStorage.getItem('token');
      
      axios_django.get(`cemeteryzak/poi/?bbox=${bbox}`, {
        headers: { Authorization: `Bearer ${token}` }
      }).then(res => {
        console.log(res.data);
        this.poi_data = res.data;
        this.$store.commit('set', ['poi_data', this.poi_data]);
      });
    },
    
    // This method binds the tooltip to each feature
    onEachFeature(feature, layer) {
      var v=this
      layer.bindPopup((e)=>{
        var table=``
          //console.log(v.diktia_ydreusis_json)
          var fields=v.info_popup[0].fields
          for(var gg=0; gg<fields.length; gg++){
              table=table+`
                <tr>
                  <td>${fields[gg].label}</td>
                  
                  
                  <td>${e.feature.properties[fields[gg].key]!==null ? e.feature.properties[fields[gg].key]: '-' }</td>
                      
                </tr>
              `
          }
          //console.log(table)
            const div = document.createElement("div");
            div.innerHTML = `<h6 class="text-center">Πληροφορίες Tάφου</h6>`;
           
           // Creating table element
            const table_div = document.createElement("table");
            table_div.setAttribute("class", "table table-bordered table-sm table-responsive");
            table_div.setAttribute("style", "max-height: 350px; min-width: 145px;");
            const tbody = document.createElement("tbody");
            tbody.innerHTML = `${table}`;
            table_div.appendChild(tbody);
            div.appendChild(table_div);
          return  div
      }); // Tooltip text set to 'test'
    }
  }
};
</script>
